/**
 * The password form's field names (JET-2155), shared by the form
 * (components/PasswordGate.vue) and the server reading it
 * (server/utils/passwordGate.ts). Isomorphic on purpose: the server module
 * pulls in node:crypto and must stay out of the client bundle.
 */
export const PASSWORD_FIELD = "ncf-password"

/** Marks a POST as the password form, so no other POST is read as one. */
export const SUBMISSION_FIELD = "ncf-gate"
